export const validatePassword = (password: string): string[] => {
  const errors: string[] = [];

  if (password.length < 8) {
    errors.push("validPassword.too_short");
  }
  if (!/[a-z]/.test(password)) {
    errors.push("validPassword.no_lowercase");
  }
  if (!/[A-Z]/.test(password)) {
    errors.push("validPassword.no_uppercase");
  }
  if (!/[0-9]/.test(password)) {
    errors.push("validPassword.no_number");
  }

  return errors;
};

export const validatePasswords = (password: string, confirmPassword: string): Record<string, string[]> => {
  const passwordErrors = validatePassword(password);
  const confirmErrors: string[] = [];

  if (password && confirmPassword && password !== confirmPassword) {
    confirmErrors.push("validPassword.mismatch");
  }

  return {
    password: passwordErrors,
    confirmPassword: confirmErrors,
  };
};
